module.exports = __webpack_public_path__ + "static/media/cSharpLogo.9896f44c.png";